module.exports = "../images/cabin-8-person-1.jpg?v=921a22f";